const NotFound = () => <div>Whoops ... nothing found here ...</div>;

export default NotFound;
